import { render, staticRenderFns } from "./CheckMobile.vue?vue&type=template&id=0065bbc6&scoped=true&"
import script from "./CheckMobile.vue?vue&type=script&lang=js&"
export * from "./CheckMobile.vue?vue&type=script&lang=js&"
import style0 from "./CheckMobile.vue?vue&type=style&index=0&id=0065bbc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065bbc6",
  null
  
)

export default component.exports